import DragDropDraggable from "./DragDropDraggable";
import DragDropDroppable from "./DragDropDroppable";
import DragDropResizable from "./DragDropResizable";

/**
 * Globals that are shared across Drag & Drop instances
 */
export default class DragDropManager
{
  /** 
   * If set (true | in msec), dragging placement (collision) will only happen after a pause by the user
   */
  public static pauseDrag: boolean | number;

  /** 
   * True if a mouse down event was handled 
   */
  public static mouseHandled: boolean;

  /** 
   * Item being dragged 
   */
  public static dragElement: DragDropDraggable;

  /** 
   * Item we are currently over as drop target 
   */
  public static dropElement: DragDropDroppable;

  /** 
   * Current item we're over for resizing purpose (ignore nested tile layout resize handles) 
   */
  public static overResizeElement: DragDropResizable;
}
